export default __webpack_public_path__ + "static/media/gif_colombia_EN.68268d80.gif";